module.exports = __webpack_public_path__ + "static/img/ruzhuLogo.c30218d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ruzhuLogo.png
// module id = JvA7
// module chunks = 18